import { ExamDateDto } from "api";
import { RegistrationJourneyState } from "journey";
export enum GT_EVENT {
  ViewItemList = "view_item_list",
  AddToCart = "add_to_cart",
  BeginCheckout = "begin_checkout",
  AddShippingInfo = "add_shipping_info",
  Purchase = "purchase",
}

export const GTag = {
  viewExamList: (exams: ExamDateDto[]) => {
    _gtag("event", GT_EVENT.ViewItemList, {
      currency: exams[0]?.currency,
      items: exams.map((exam, index) => ({
        ...mapExamToItem(exam),
        index,
      })),
    });
  },
  addToCart: (exam?: ExamDateDto) => {
    _gtag("event", GT_EVENT.AddToCart, {
      value: exam?.price,
      currency: exam?.currency,
      items: [mapExamToItem(exam)],
    });
  },
  beginCheckout: (exam?: ExamDateDto) => {
    _gtag("event", GT_EVENT.BeginCheckout, {
      value: exam?.price,
      currency: exam?.currency,
      items: [mapExamToItem(exam)],
    });
  },
  addShippingInfo: (exam?: ExamDateDto) => {
    _gtag("event", GT_EVENT.AddShippingInfo, {
      value: exam?.price,
      currency: exam?.currency,
      items: [mapExamToItem(exam)],
    });
  },
  setUserData: (details: RegistrationJourneyState["candidateDetails"]) => {
    _gtag("set", "user_data", {
      email: details?.emailAddress,
      phone_number: details?.phoneNumber,
      address: {
        first_name: details?.firstName,
        last_name: details?.lastName,
        street: details?.address.street,
        city: details?.address.city,
        postal_code: details?.address.postalCode,
      },
    });
  },
  purchase: (exam?: ExamDateDto, transactionId?: string) => {
    _gtag("event", GT_EVENT.Purchase, {
      transaction_id: transactionId,
      value: exam?.price,
      currency: exam?.currency,
      items: [mapExamToItem(exam)],
    });
  },
};

const _gtag: Gtag.Gtag = (command, ...args) => {
  if (typeof gtag === "function") {
    gtag(command, ...args);
  }
};

const mapExamToItem = (exam?: ExamDateDto) => ({
  item_id: exam?.id,
  item_name: exam?.examName,
  item_brand: "Cambridge",
  item_category: exam?.examFormat,
  item_category2: exam?.city,
  item_category3: exam?.photoRequired ? "Photo required" : "",
  location_id: exam?.centreCode,
  price: exam?.price,
  quantity: 1,
  exam_date: exam?.examDate,
});
